import { UpdateVehicleInput } from "@/gql/graphql";
import { RecordScreenFormCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenFormCard";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updateVehicleMutation } from "@/app/Vehicles/GraphQL/vehicleMutations";
import { useVehicleRecord } from "@/app/Vehicles/Hooks/useVehicleRecord";
import { mapVehicleModelToInput } from "@/app/Vehicles/Utils/mapVehicleModelToInput";
import {
  VehicleBasicForm,
  VehicleSpecificationsForm,
  VehicleRatesForm,
  VehicleFeaturesForm,
} from "@/app/Vehicles/Components/VehicleFormSections";

export function VehicleDetailsScreen() {
  const record = useVehicleRecord();
  const { mutateAsync } = useGqlMutation(updateVehicleMutation);
  const initialValues = mapVehicleModelToInput(record);

  async function handleSubmit(values: UpdateVehicleInput) {
    await mutateAsync({
      id: record.id,
      input: values,
    });
  }

  return (
    <div className="space-y-8 py-6">
      {/* Basic Information */}
      <RecordScreenFormCard<UpdateVehicleInput>
        title="Basic Information"
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        <VehicleBasicForm />
      </RecordScreenFormCard>

      {/* Specifications */}
      <RecordScreenFormCard<UpdateVehicleInput>
        title="Specifications"
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        <VehicleSpecificationsForm />
      </RecordScreenFormCard>

      {/* Rates & Pricing */}
      <RecordScreenFormCard<UpdateVehicleInput>
        title="Rates & Pricing"
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        <VehicleRatesForm />
      </RecordScreenFormCard>

      {/* Features */}
      <RecordScreenFormCard<UpdateVehicleInput>
        title="Features"
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        <VehicleFeaturesForm />
      </RecordScreenFormCard>
    </div>
  );
}
